import type { FaireProductEntity } from "../../entity_types/product";

export const p_vwtvn3x6ep: FaireProductEntity = {
  token: "p_vwtvn3x6ep",
  type: "product",
  name: "Protection Aromatherapy Body & Room Myst",
  brandToken: "b_we9tdmh5ka",
  brandName: "The Sacred Wild Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/0db98a389f56f97526052d486194372f8ce80fc69a8e9c42927cf4188336d446.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/983803774e4f00f3166b667ab80506c72d18aaea6ab2071183dd9f22d46edf9e.jpeg",
    "https://cdn.faire.com/fastly/3535eb25b05e3714f1fea797b04d4b675510a221e368effeb7d9ecdca19516cc.jpeg",
    "https://cdn.faire.com/fastly/276670d4fcaae6dc6878877811cd1dc6d7a625af564fbb304621311c9f1c9f24.jpeg",
    "https://cdn.faire.com/fastly/cda752512d373caeb569a1da622e1ec74ecd00698ee35c3811626856944a5944.jpeg",
    "https://cdn.faire.com/fastly/bd4a510d9563fc45a46b2c6d5a8aab3441979ad70fe8bdbab827a019f0e24e7c.jpeg",
    "https://cdn.faire.com/fastly/7db159f80d23e2904ce46db599b02635c1e91c41260584098083de09b969ab4d.jpeg",
    "https://cdn.faire.com/fastly/b2a1b5b0dfdef1d8929c4c4c1c611bea30ca4dde25f57fb15ea1bff51514f470.jpeg",
  ],
  priceDollars: 16.28,
  description:
    "A deep and complex blend of Palo Santo, Sage and Patchouli for the perfect Smokeless Smudge. \n\nWe’ve taken our signature, plant-based and non-toxic essential oil fragrances and formulated them into an indulgent room and body myst for an instant aromatherapeutic effect. \n\nBecause of our Natural Skin Safe Formula (NO parabens, phthalates, aerosols, or alcohol) separation can occur on the shelf...please shake occasionally! \n\nScent Notes: Wisps of palo santo. Meditation at dawn. Midnight patchouli. \n\nHow to use : Spray this fragrant mist around your personal space and repeat the mantra: I am protected, I am safe, I am supported.\n\nAll of our scents are inspired by the earth to keep your feet grounded and your mind still to empower self-esteem, confidence and focus. \n\n++++Please see our separate product listing to order testers++",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:00.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
